import { forwardRef } from 'react';

import { StyledTextButton } from './TextButton.styled';
import type { TextButtonProps } from './types';

const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ color = 'brand', size = 'sm', ...props }, ref) => (
    <StyledTextButton ref={ref} $color={color} $size={size} {...props} />
  ),
);

TextButton.displayName = 'TextButton';

export default TextButton;
